// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_42-2";
export var blackBorderOnHover = "_42-7";
export var cell = "_42-6";
export var cellContainer = "_42-3";
export var checked = "_42-8";
export var disabled = "_42-5";
export var featuredIconCellContainer = "_42-9";
export var featuredIconTextContainer = "_42-b";
export var featuredIconWrapper = "_42-a";
export var noBorder = "_42-c";
export var orangeSelectedRow = "_al-3";
export var overflowableText = "_42-0";
export var overflowableTextContainer = "_42-1";
export var row = "_44-0";
export var rowCheckboxCell = "_42-4";
export var selectableTable = "_al-2";